import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import axios, { AxiosError } from "axios";
var baseConfig = {
    timeout: 8000,
    withCredentials: true,
    headers: {
        "client-id": "web"
    }
};
var axiosInstance = axios.create(baseConfig);
var getApi = function(host, config) {
    var version = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "v1", protocol = arguments.length > 3 ? arguments[3] : void 0;
    var baseURL = "".concat(protocol || "https", "://").concat(host, "/").concat(version);
    return axios.create(_object_spread_props(_object_spread({
        baseURL: baseURL
    }, baseConfig, config), {
        headers: _object_spread({}, baseConfig.headers, config === null || config === void 0 ? void 0 : config.headers)
    }));
};
var API;
(function(API) {
    API["accountLogin"] = "/auth/v1/login";
    API["accountResendConfirmUser"] = "/user-profile/v1/resend-confirm-user";
    API["accountSession"] = "/user_account/session.php";
    API["openingHours"] = "/infoline/times";
    API["siteSettings"] = "/site/settings";
    API["searchCars"] = "/quotes";
})(API || (API = {}));
export { axiosInstance, AxiosError, getApi, API };
